import { useRef } from 'react';
import { useWheelNavigation } from '../hooks/useWheelNavigation';
import { useStore } from '../store/useStore';

export const FullScreenListView = ({ activeMenuLevel, config, flatItems, selectedIndex, setSelectedIndex, handleItemSelect, labels }: any) => {
  const scrollRef = useRef(null);
  const title = labels[activeMenuLevel] || 'List';
  const activeCompany = useStore((state) => state.activeCompany);
  useWheelNavigation(scrollRef, flatItems.length, setSelectedIndex, false, () => flatItems && flatItems[selectedIndex] && handleItemSelect(flatItems[selectedIndex], selectedIndex));

  return (
    <div className="flex flex-col w-full h-full bg-white z-20 absolute inset-0">
      <div className="bg-[#1e8585] text-white flex justify-between px-3 py-1 text-[13px] font-semibold shadow-sm z-10">
        <span className="w-1/3 text-left">Chart of Accounts</span>
        <span className="w-1/3 text-center">{activeCompany?.name || config.companyList[0].name}</span>
        <span className="w-1/3 text-right"></span>
      </div>
      <div className="bg-white text-black flex justify-between px-3 py-1 text-[12px] font-bold border-b border-gray-300 z-10 shadow-sm">
        <span>List of {title}</span><span>For 1-Apr-26</span>
      </div>
      <div ref={scrollRef} className="flex-1 overflow-y-auto py-1 bg-[#fdfdfd] scrollbar-thin">
        {flatItems.map((item: any, idx: number) => (
          <div key={idx} onClick={() => handleItemSelect(item, idx)}
            style={{ paddingLeft: `${12 + (item.indent || 0) * 20}px` }}
            className={`py-[2px] pr-3 cursor-pointer flex justify-start ${selectedIndex === idx ? 'bg-[#1e8585] text-white font-medium active-row' : 'text-black'} ${(item.indent || 0) > 0 ? 'text-[12px] font-normal' : 'font-bold text-[13px]'}`}
          >{item.name}</div>
        ))}
      </div>
      <div className="bg-white border-t border-gray-300 px-3 py-1 text-[12px] font-bold text-black flex justify-start z-10">
        <span>{flatItems.length} {title}(s)</span>
      </div>
    </div>
  );
};
